import { Timestamp } from "firebase/firestore";
import { formatDate } from "../utils/formatting";
import { getFiscalYearStart } from "./fiscalYear";

// 現在の期の初日(6月1日 0時0分0秒)を、用途別の3つの表現で返す。
// 「期首は6月1日」というルール自体は fiscalYear.js に一本化してある
// (日付編集UIでの期の表示と同じロジックを使うため)。
function getFiscalYearStartDate() {
  const fiscalYearStartDate = getFiscalYearStart(new Date());

  return {
    // Dateオブジェクト
    dateObj: fiscalYearStartDate,
    // FirestoreのTimestamp型
    timeStamp: Timestamp.fromDate(fiscalYearStartDate),
    // "YYYY-MM-DD"形式の文字列
    dateString: formatDate(fiscalYearStartDate),
  };
}
export default getFiscalYearStartDate;
